(() => {
  const mounted = new WeakMap();
  const mount = root => {
    if (mounted.has(root)) return;
    const controller = new AbortController(), signal = controller.signal;
    const submit = root.querySelector('[data-mademap-submit]');
    const input = root.querySelector('.product-variant-id');
    const variants = JSON.parse(root.querySelector('[data-mademap-variants]').textContent);
    const copy = JSON.parse(root.querySelector('[data-mm26-copy]').textContent);
    const sticky = root.querySelector('[data-mm26-sticky]');
    const action = root.querySelector('[data-mm26-action]');
    const stickyPrice = root.querySelector('[data-mm26-sticky-price]');
    let visible = false;
    const sync = () => {
      const v = variants.find(v => String(v.id) === input.value);
      const busy = submit.classList.contains('loading') || submit.getAttribute('aria-disabled') === 'true';
      action.disabled = submit.disabled || busy;
      action.textContent = busy && !submit.disabled ? copy.adding : submit.disabled ? root.dataset.soldOutLabel : copy.add;
      stickyPrice.textContent = v?.formattedPrice || '';
      const badge=root.querySelector('[data-mm26-sale]');
      const onSale=v && Number(v.compareAtPrice)>Number(v.price);
      badge.hidden=!onSale;
      badge.textContent=onSale?`−${Math.round((v.compareAtPrice-v.price)*100/v.compareAtPrice)}%`:'';
      sticky.hidden = visible;
    };
    const observer = new MutationObserver(sync);
    observer.observe(submit,{attributes:true,attributeFilter:['disabled','aria-disabled','class']});
    const intersection = new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();});
    intersection.observe(submit);
    root.querySelector('[data-mademap-variant-select]')?.addEventListener('change',()=>queueMicrotask(sync),{signal});
    action.addEventListener('click',()=>{if(!action.disabled)submit.click();},{signal});
    const dialog=root.querySelector('[data-mm26-dialog]'), image=root.querySelector('[data-mm26-image]');
    const thumbs=[...root.querySelectorAll('[data-mademap-media]')];
    const box=root.querySelector('.mm26-dialog-image');let index=0,returnFocus;
    const show = n => {index=(n+thumbs.length)%thumbs.length;image.src=thumbs[index].dataset.src;image.alt=thumbs[index].dataset.alt||'';root.querySelector('[data-mm26-counter]').textContent=`${index+1} / ${thumbs.length}`;box.classList.remove('is-zoomed');box.scrollTop=box.scrollLeft=0;};
    root.querySelector('[data-mm26-zoom]').addEventListener('click',e=>{returnFocus=e.currentTarget;show(Math.max(0,thumbs.findIndex(t=>t.classList.contains('is-active'))));dialog.showModal();},{signal});
    root.querySelector('[data-mm26-close]').addEventListener('click',()=>dialog.close(),{signal});
    root.querySelector('[data-mm26-next]').addEventListener('click',()=>show(index+1),{signal});
    root.querySelector('[data-mm26-prev]').addEventListener('click',()=>show(index-1),{signal});
    image.addEventListener('click',()=>box.classList.toggle('is-zoomed'),{signal});
    dialog.addEventListener('close',()=>returnFocus?.focus(),{signal});
    dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();},{signal});
    dialog.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(index+(e.key==='ArrowRight'?1:-1));}},{signal});
    const preview = () => {
      const frame=document.querySelector('#shopify-preview-bar-iframe');const rect=frame?.getBoundingClientRect();
      const offset=rect&&rect.height&&rect.top<innerHeight?Math.max(0,innerHeight-rect.top):document.querySelector('#PBarNextFrame')?80:0;
      root.style.setProperty('--mm26-preview-offset',`${offset}px`);
      document.documentElement.style.setProperty('--mm26-preview-offset',`${offset}px`);
    };
    window.addEventListener('resize',preview,{signal});preview();sync();
    mounted.set(root,()=>{controller.abort();observer.disconnect();intersection.disconnect();if(dialog.open)dialog.close();});
  };
  const start=(scope=document)=>scope.querySelectorAll('mademap-product-v2').forEach(mount);
  customElements.whenDefined('mademap-product-v2').then(()=>start());
  document.addEventListener('shopify:section:load',e=>start(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('mademap-product-v2').forEach(root=>{mounted.get(root)?.();mounted.delete(root);}));
})();
